import './App.css';
import { CssBaseline } from "@mui/material";
import Home from './pages/Home/Home';

function App() {
  return (
    <div className="App">
      <CssBaseline />
      <Home />
    </div>
  );
}

export default App;
